import { type Component, For, Show } from "solid-js"
import CheckCircle from "../../assets/heroicons/CheckCircle"
import { type OfferingProps } from "../shared/offering-props"
import WebinarPurchaseButtonB from "./WebinarPurchaseButtonB"
import MiniStar from "../../assets/heroicons/MiniStar"
import { Trans } from "@mbarzda/solid-i18next"
import CountdownTimer from '../shared/components/CountdownTimer'

const WebinarOfferingBoxB: Component<OfferingProps> = (props) => {
  const features = [
    { key: "<strong>4,000 AI credits</strong> per week" },
    { key: "<strong>Professional</strong> Product Finder" },
    { key: "<strong>All time</strong> Profit Tracking" },
    { key: "<strong>All time</strong> Order Reports" },
    { key: "<strong>All time</strong> Product Reports" },
    { key: "<strong>All time</strong> Listing Reports" },
    { key: "<strong>All time</strong> Advertisement Reports" },
    { key: "<strong>Tracking</strong> Last 30 Days + Totals" },
    { key: "<strong>Unlimited</strong> Etsy Shops" },
    { key: "<strong>Print on Demand</strong> Integrations" },
  ]

  return (
    <div class='w-[370px] flex flex-col gap-2 justify-center items-center text-center'>
      <div class='flex flex-col w-full overflow-hidden rounded-xl shadow-md'>
        <div class='bg-gray-700 text-white text-2xl leading-8 font-semibold font-poppins rounded-t-xl px-6 py-3 text-start'>
          🚀 ProfitTree Pro
        </div>
        <CountdownTimer storageKey="offer_b_deadline" />
        <div class='flex flex-col w-full bg-white p-6 gap-4 rounded-b-xl'>
        <div class='text-center'>
          <div class='flex flex-col gap-2 font-medium font-poppins leading-6 text-gray-700'>
            <p>Monthly plan price per year: <span class='text-red-500'>$599.88</span></p>
            <p>Annual plan price: <span class='text-red-500'>$359.88</span></p>
          </div>
          <div class='mt-4 text-3xl font-bold text-gray-900'>
            Today's Price: <span class='text-green-500'>$179.99</span>{" "}
            for 1 Year
          </div>
        </div>

        <div class='flex flex-col gap-6 w-full'>
          <div class='flex flex-col gap-4'>
            <div class='flex flex-col gap-y-2'>
              <div class='text-gray-700 text-sm leading-6 space-y-2'>
                <For each={features}>
                  {(feat) => (
                    <div class='flex items-start gap-2'>
                        <span class='text-green-600 mt-1'>
                        <CheckCircle size={4} />
                      </span>
                      <span class='text-base leading-6 font-normal' innerHTML={feat.key} />
                    </div>
                  )}
                </For>
                <div class='flex items-center gap-2'>
                  <span class='text-yellow-400 mt-1'>
                    <MiniStar size={4} />
                  </span>
                  <span class='text-base leading-6 font-normal'><strong>Early-Access</strong> to New Features!</span>
                </div>
              </div>
            </div>
          </div>
          <Show when={props.showButton}>
            <div>
              <WebinarPurchaseButtonB showCheckout={props.showCheckout} fullWidth={true} />
            </div>
          </Show>
        </div>
        <div class='flex flex-col justify-center text-gray-700 text-sm font-medium font-poppins'>
          <span>💰 Save <strong>$419.89</strong> vs monthly pricing</span>
        </div>
        </div>
      </div>
      <span class='font-sans text-sm text-gray-50'>
        <Trans key={"ls_webinar_offering_note"} />
      </span>
    </div>
  )
}

export default WebinarOfferingBoxB
